import { render, staticRenderFns } from "./ReportSwipe.vue?vue&type=template&id=1422ccc8&scoped=true"
import script from "./ReportSwipe.vue?vue&type=script&lang=js"
export * from "./ReportSwipe.vue?vue&type=script&lang=js"
import style0 from "./ReportSwipe.vue?vue&type=style&index=0&id=1422ccc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422ccc8",
  null
  
)

export default component.exports